// The SPA and /api share one ingress. Use the configured origin for both,
// so fresh visitors never need cross-site cookies just to register or sign in.
export const canonicalAppUrl = (currentHref, configuredBackendUrl) => {
  const current = new URL(currentHref);
  const target = new URL(configuredBackendUrl);
  if (!["https:", "http:"].includes(target.protocol) || target.username || target.password) {
    throw new Error("Invalid application origin configuration");
  }
  if (current.origin === target.origin) return null;
  // Assign URL components rather than resolving user-controlled // paths.
  target.pathname = current.pathname;
  target.search = current.search;
  target.hash = current.hash;
  return target.href;
};